{
  "nav": {
    "home": "Accueil",
    "tutorials": "Tutoriels",
    "barcodes": "Codes-barres",
    "contact": "Nous contacter",
    "logout": "Déconnexion",
    "logoAlt": "DinLabel",
    "download": "Télécharger",
    "downloadDemo": "Télécharger la démo",
    "buy": "Acheter",
    "login": "Connexion",
    "myAccount": "Mon compte",
    "language": "Langue",
    "distributorPortal": "Portail distributeurs"
  },
  "language": {
    "title": "Langue",
    "description": "Choisissez la langue de l'application. Par défaut, la langue du navigateur est utilisée.",
    "browser": "Utiliser la langue du navigateur",
    "english": "Anglais",
    "spanish": "Espagnol",
    "german": "Allemand",
    "french": "Français"
  },
  "offline": {
    "title": "Hors ligne",
    "message": "L'application ne peut pas se connecter au serveur :( !!"
  },
  "dialogs": {
    "apiError": "Erreur API",
    "confirmYes": "Oui",
    "cancel": "Annuler",
    "send": "Envoyer"
  },
  "portal": {
    "pageTitle": "Portail distributeurs",
    "actions": "Actions",
    "authorized": "Autorisé",
    "pending": "En attente d'approbation",
    "buyLicenses": "Acheter des licences",
    "pendingApproval": "Votre demande de distributeur n'a pas encore été approuvée – pour toute question, vous pouvez contacter {{email}}. Ce processus ne devrait pas prendre plus de 2 jours ouvrables.",
    "distributorInfo": "Informations pour les distributeurs",
    "loading": "Chargement des informations du distributeur…",
    "loadError": "Impossible de charger les informations du distributeur."
  },
  "licenses": {
    "noneAvailable": "Vous n'avez actuellement aucune licence disponible à envoyer.",
    "statAvailable": "Disponibles à envoyer",
    "statBought": "Achetées",
    "statSent": "Envoyées",
    "sentHistory": "Licences envoyées",
    "activatedYes": "Activée",
    "buyTitle": "Portail distributeurs - Acheter des licences",
    "buyLoading": "Chargement…",
    "buyLoadError": "Impossible de charger les informations du distributeur.",
    "buyIntro": "Indiquez le nombre de licences que vous souhaitez acheter – le prix distributeur est de {{price}} pesos. Les distributeurs peuvent vendre DinLabel comme ils le jugent approprié, mais notre prix recommandé est de {{recommended}} pesos.",
    "licenseCountLabel": "Nombre de licences",
    "costSummary": "Le coût de {{count}} licences est de {{cost}} pesos + taxes.",
    "buyButton": "Acheter {{count}} licences",
    "sendTitle": "Envoyer une licence",
    "resendConfirm": "Voulez-vous renvoyer la licence à {{email}} ?",
    "sendPrompt": "Entrez l'e-mail auquel vous souhaitez envoyer",
    "emailPlaceholder": "email@exemple.com",
    "errorTitle": "Erreur !",
    "sendError": "Une erreur s'est produite lors de l'envoi de la licence {{error}}",
    "resentTitle": "Licence renvoyée !",
    "resentMessage": "La licence a été renvoyée à {{email}} avec copie à {{cc}}",
    "sentTitle": "Licence envoyée !",
    "sentMessage": "La licence a été envoyée à {{email}} avec copie à {{cc}}",
    "sendToEmail": "Envoyer la licence par e-mail...",
    "recipient": "Destinataire de la licence",
    "date": "Date",
    "sent": "Envoyée",
    "activated": "Activée",
    "notActivated": "Pas encore activée",
    "resend": "Renvoyer la licence"
  },
  "register": {
    "title": "Devenir distributeur",
    "intro": "Pour accéder au portail distributeurs DinLabel, vous devez d'abord vous inscrire :",
    "company": "Entreprise",
    "companyPlaceholder": "Nom de l'entreprise",
    "phone": "Téléphone",
    "phonePlaceholder": "Téléphone",
    "phoneDescription": "Assurez-vous d'inclure l'indicatif du pays, par exemple +33 1...",
    "street": "Rue",
    "street1Placeholder": "Rue 1",
    "street2Placeholder": "Rue 2",
    "number": "Numéro",
    "city": "Ville",
    "state": "Région",
    "country": "Pays",
    "zip": "Code postal",
    "rfc": "Identifiant fiscal",
    "nextSteps": "Vous recevrez un e-mail avec les prochaines étapes",
    "submit": "Envoyer"
  },
  "faq": {
    "qGoogleAccount": "Ai-je besoin d'un compte Google pour être distributeur DINLabel ?",
    "aGoogleAccount": "Oui, vous avez besoin d'un compte Google. Si vous en avez déjà un, vous pouvez l'utiliser pour vous connecter au portail distributeurs.",
    "qRequirements": "Que dois-je faire pour devenir distributeur DINLabel ?",
    "aRequirementsBefore": "Inscrivez-vous en tant que distributeur dans le",
    "aRequirementsLink": "portail distributeurs",
    "aRequirementsAfter": "et attendez de recevoir l'e-mail de confirmation vous autorisant en tant que distributeur DINLabel.",
    "qAnyoneCanSell": "Toute personne ou entreprise peut-elle vendre DINLabel ?",
    "aAnyoneCanSell": "Oui, il suffit de s'inscrire sur le portail distributeurs DINLabel et de recevoir l'e-mail de confirmation.",
    "qHowManyDistributors": "Combien de distributeurs peut-il y avoir chez DINLabel ?",
    "aHowManyDistributors": "Il n'y a pas de limite.",
    "qDistributorCost": "Combien coûte une licence DINLabel pour un distributeur ?",
    "aDistributorCost": "112 USD plus taxes par licence.",
    "qRecommendedPrice": "Quel est le prix de vente recommandé du distributeur à ses clients pour une licence DINLabel ?",
    "aRecommendedPrice": "Le distributeur fixe le prix ; il n'y a pas de prix fixe. Nous suggérons un prix de vente de 160 USD plus taxes. Les clients directs sur le portail DinLabel s'abonnent pour 15 USD par mois plus taxes.",
    "qWhereToBuy": "Où un utilisateur final peut-il obtenir DinLabel ?",
    "aWhereToBuyBefore": "Les nouveaux clients s'abonnent mensuellement sur la page d'achat, ou obtiennent une licence auprès d'un distributeur. Les acheteurs ponctuels existants conservent un accès à vie. Achetez ou abonnez-vous sur le portail",
    "qHowBuyAsDistributor": "En tant que distributeur, comment acheter des licences DINLabel ?",
    "aHowBuyAsDistributorBefore": "Via le portail distributeurs, en allant dans la section Acheter des licences. Voir le tutoriel",
    "aHowBuyAsDistributorLink": "comment acheter des licences.",
    "qMinimumLicenses": "En tant que distributeur, lors de l'achat de licences pour les revendre à mes clients, quel est le nombre minimum de licences à acheter ?",
    "aMinimumLicenses": "Il n'y a pas de minimum ; vous pouvez acheter à partir de 1 licence.",
    "qHowDeliver": "En tant que distributeur, comment livrer une licence DINLabel à mon client ?",
    "aHowDeliverBefore": "Via le portail distributeurs, dans la section",
    "aHowDeliverSendLink": "envoyer des licences",
    "aHowDeliverMiddle": " ; voir le",
    "aHowDeliverTutorialLink": "tutoriel sur l'envoi de licences.",
    "qHowLongPurchase": "Combien de temps faut-il pour acheter une licence en tant que distributeur et la livrer au client ?",
    "aHowLongPurchase": "Si vous êtes déjà enregistré en tant que distributeur, l'achat et la livraison de la licence peuvent se faire en quelques minutes.",
    "qHowLongToSell": "En tant que distributeur, combien de temps ai-je pour vendre les licences achetées sur le portail ?",
    "aHowLongToSell": "Les licences distributeur n'expirent pas. Lorsque vous achetez des licences, elles sont ajoutées à votre inventaire et vous pouvez les utiliser à tout moment.",
    "qHowManyAvailable": "Comment savoir combien de licences j'ai en tant que distributeur ?",
    "aHowManyAvailableBefore": "Lorsque vous entrez dans le",
    "aHowManyAvailableLink": "portail distributeurs",
    "aHowManyAvailableAfter": " DINLabel, le premier écran affiche votre solde de licences disponibles à envoyer.",
    "qSoldLicenses": "Comment savoir quelles licences j'ai vendues et à qui ?",
    "aSoldLicensesBefore": "Via le portail distributeurs DINLabel dans la section",
    "aSoldLicensesLink": "voir les détails",
    "qTryBefore": "Puis-je essayer DINLabel avant de devenir distributeur ?",
    "aTryBeforeBefore": "Oui, vous pouvez télécharger une démo sur",
    "aTryBeforeAfter": "et l'essayer.",
    "qMainFaq": "Y a-t-il des FAQ (foire aux questions) sur le portail DINLabel ?",
    "aMainFaqBefore": "Sur",
    "aMainFaqAfter": "vous trouverez les questions les plus fréquentes sur l'utilisation du système DINLabel.",
    "qTutorials": "Y a-t-il des tutoriels pour utiliser DINLabel ?",
    "aTutorialsBefore": "Sur",
    "aTutorialsAfter": "vous trouverez tous les tutoriels nécessaires pour utiliser DINLabel.",
    "qSupport": "En tant que distributeur, ai-je un support technique ?",
    "aSupport": "Par e-mail ; voir la fin de cette FAQ.",
    "qOtherQuestion": "J'ai une question qui n'est pas dans la liste. Que puis-je faire ?",
    "aOtherQuestionBefore": "Nous serions ravis de vous aider. Allez à",
    "aOtherQuestionLink": "nous contacter",
    "aOtherQuestionAfter": ", envoyez vos questions, et nous vous répondrons volontiers."
  },
  "tutorials": {
    "title": "Tutoriels",
    "alsoSeeFaqBefore": "Vous pouvez aussi consulter la",
    "alsoSeeFaqLink": "FAQ",
    "sendLicenseTutorial": "Tutoriel : Comment envoyer une licence depuis le portail distributeurs",
    "iframeTitle": "Tutoriel envoi de licence"
  },
  "home": {
    "welcome": "Bienvenue, {{email}}",
    "error": "Erreur"
  },
  "userLicenses": {
    "hasLicense": "Vous avez déjà un accès complet à DinLabel.",
    "hasSubscription": "Votre abonnement DinLabel est actif.",
    "manageBilling": "Gérer la facturation",
    "noLicense": "Vous n'avez pas d'abonnement DinLabel actif",
    "buyHere": "S'abonner ici"
  },
  "signin": {
    "title": "Connexion",
    "intro": "Connectez-vous avec Google ou avec votre e-mail et mot de passe.",
    "withGoogle": "Se connecter avec Google",
    "orEmail": "ou",
    "email": "E-mail",
    "password": "Mot de passe",
    "withEmail": "Se connecter avec e-mail",
    "createAccount": "Créer un compte",
    "forgotPassword": "Mot de passe oublié ?",
    "emailPasswordError": "Connexion impossible. Vérifiez votre e-mail et mot de passe.",
    "agreePrefix": "En continuant, vous acceptez notre",
    "privacyLink": "Politique de confidentialité et conditions d'utilisation",
    "alreadySignedIn": "Vous êtes déjà connecté",
    "signedInAs": "Connecté en tant que {{email}}",
    "continue": "Continuer",
    "debugSignInUrl": "URL de connexion"
  },
  "registerAccount": {
    "title": "Créer un compte",
    "intro": "Inscrivez-vous avec votre e-mail et un mot de passe.",
    "email": "E-mail",
    "password": "Mot de passe",
    "passwordHint": "Au moins 8 caractères",
    "submit": "Créer le compte",
    "haveAccount": "Vous avez déjà un compte ?",
    "signIn": "Se connecter",
    "error": "Impossible de créer le compte.",
    "googleExists": "Cet e-mail est déjà enregistré avec Google. Connectez-vous avec Google, puis ajoutez un mot de passe dans Mon compte si vous le souhaitez."
  },
  "forgotPassword": {
    "title": "Mot de passe oublié",
    "intro": "Entrez votre e-mail. Si un compte existe, nous enverrons un lien de réinitialisation.",
    "email": "E-mail",
    "submit": "Envoyer le lien",
    "sent": "Si un compte existe pour cet e-mail, un lien de réinitialisation a été envoyé.",
    "backToSignIn": "Retour à la connexion",
    "error": "Impossible d'envoyer l'e-mail de réinitialisation."
  },
  "resetPassword": {
    "title": "Réinitialiser le mot de passe",
    "password": "Nouveau mot de passe",
    "passwordHint": "Au moins 8 caractères",
    "submit": "Mettre à jour le mot de passe",
    "success": "Votre mot de passe a été mis à jour.",
    "signIn": "Se connecter",
    "backToSignIn": "Retour à la connexion",
    "invalidLink": "Ce lien de réinitialisation est invalide ou incomplet.",
    "error": "Impossible de réinitialiser le mot de passe."
  },
  "applogin": {
    "title": "Continuer dans DinLabel",
    "intro": "Continuez pour terminer la connexion à l'application de bureau.",
    "signedInAs": "Vous êtes connecté en tant que {{email}}.",
    "continue": "Continuer",
    "switchAccount": "Utiliser un autre compte",
    "redirecting": "Redirection vers la connexion…",
    "invalidTitle": "Lien de connexion non valide",
    "invalidBody": "Cette page est ouverte par l'application de bureau DinLabel. Veuillez démarrer la connexion depuis l'application."
  },
  "marketing": {
    "headline": "Logiciel professionnel pour la gestion et l'impression d'étiquettes",
    "slogan": "Configurez et imprimez facilement sur imprimantes thermiques (Zebra et plus), laser et jet d'encre. Ajoutez textes, codes-barres, données variables et numérotation séquentielle sur étiquettes en tissu, carton ou adhésives.",
    "featureNumbers": "Numérotation séquentielle et compteurs",
    "featureImages": "Logos et images nets",
    "featureVariable": "Données variables sans complication",
    "featureQr": "Codes QR interactifs",
    "featureText": "Texte clair et lisible",
    "featureBarcode": "Codes-barres professionnels",
    "featureDemo": {
      "productName": "Nom du produit",
      "oliveOil": "Huile d'olive",
      "oliveOilDesc": "Description de l'huile d'olive",
      "fontsNote": "Polices claires, fines et lisibles",
      "sequence": "Séquence {{n}}",
      "client": "CLIENT :",
      "name": "Nom",
      "city": "VILLE :",
      "companyLogo": "Logo d'entreprise"
    },
    "featuresTitle": "Tout ce dont vous avez besoin sur une étiquette",
    "featuresSubtitle": "Créez des étiquettes professionnelles avec les outils sur lesquels s'appuient les imprimeries et les entrepôts chaque jour.",
    "seeBarcodeTypes": "Voir les types de codes-barres pris en charge",
    "printersTitle": "Compatible avec n'importe quelle imprimante",
    "printersSubtitle": "DinLabel se connecte directement aux imprimantes que vous utilisez déjà dans votre entreprise via les pilotes Windows standard.",
    "printersTypesTitle": "Types d'imprimantes et supports :",
    "printersThermalLabel": "Thermiques et transfert thermique :",
    "printersThermalBody": "Idéales pour les étiquettes en rouleau adhésives, Tyvek, nylon, carton, etc.",
    "printersLaserLabel": "Laser et jet d'encre (Inkjet) :",
    "printersLaserBody": "Idéales pour les planches de feuilles adhésives, carton ou tissu.",
    "whyTitle": "Pourquoi DinLabel ?",
    "whyCompatLabel": "Compatibilité totale :",
    "whyCompatBody": "Imprimez sur n'importe quelle imprimante (thermique, laser et jet d'encre) en rouleaux ou en planches.",
    "whyCostLabel": "Sans coûts gonflés :",
    "whyCostBody": "Toutes les fonctions professionnelles sans payer des licences d'entreprise exorbitantes.",
    "whySupportLabel": "Un vrai support technique :",
    "whySupportBody": "Nous vous aidons pas à pas, du téléchargement et de l'installation jusqu'à l'impression de vos étiquettes.",
    "tryTitle": "Essayez DinLabel gratuitement dès aujourd'hui",
    "trySubtitle": "Téléchargez la version démo gratuite, connectez l'imprimante que vous avez (thermique, laser ou jet d'encre) et vérifiez comment elle imprime vos étiquettes en quelques minutes.",
    "needHelp": "Besoin d'aide ?",
    "customerService": "Service client",
    "customerServiceText": "Contactez-nous par e-mail et nous vous aiderons volontiers.",
    "tutorialsText": "Tutoriels vidéo étape par étape pour chaque fonctionnalité."
  },
  "barcodes": {
    "title": "Types de codes-barres dans DinLabel",
    "intro": "DinLabel imprime les types de codes-barres les plus utilisés sur les étiquettes de vente, d'expédition et industrielles. Les types ci-dessous apparaissent en premier lorsque vous ajoutez un code-barres. Choisissez Afficher plus dans l'éditeur pour utiliser l'un des types supplémentaires pris en charge.",
    "commonTitle": "Types de codes-barres les plus courants",
    "commonIntro": "Ce sont les types que nous recommandons pour la plupart des étiquettes. DinLabel les prend tous en charge d'emblée.",
    "fullTitle": "Tous les types de codes-barres pris en charge",
    "fullIntro": "L'éditeur de codes-barres affiche ces noms lorsque vous choisissez Afficher plus. Utilisez dans DinLabel le même nom que celui indiqué ici.",
    "fullCount": "DinLabel prend en charge {{count}} types de codes-barres.",
    "ctaInstall": "Télécharger DinLabel",
    "ctaTutorials": "Voir les tutoriels codes-barres",
    "common": {
      "UpcA": {
        "name": "UPC-A",
        "description": "Le code-barres à 12 chiffres présent sur la plupart des produits vendus en Amérique du Nord."
      },
      "UpcE": {
        "name": "UPC-E",
        "description": "Un UPC compact à 6 chiffres pour les petits emballages trop étroits pour l'UPC-A."
      },
      "Ean13": {
        "name": "EAN-13",
        "description": "Le code-barres de vente à 13 chiffres utilisé dans le monde, y compris en Europe et en Amérique latine."
      },
      "Ean8": {
        "name": "EAN-8",
        "description": "Un EAN plus court pour les petits produits trop étroits pour l'EAN-13."
      },
      "Code128": {
        "name": "Code 128",
        "description": "Un code linéaire haute densité pour lettres, chiffres et symboles. Courant en expédition et en inventaire."
      },
      "GS1128": {
        "name": "GS1-128",
        "description": "Code 128 avec identifiants d'application GS1 pour la logistique, le GTIN, le lot et les dates."
      },
      "Code39": {
        "name": "Code 39",
        "description": "Un code industriel très utilisé qui encode lettres, chiffres et quelques symboles."
      },
      "Interleaved2of5": {
        "name": "Interleaved 2 of 5",
        "description": "Un code numérique compact utilisé en entrepôt, distribution et étiquetage industriel."
      },
      "Itf14": {
        "name": "ITF-14",
        "description": "Un code à 14 chiffres pour les cartons d'expédition et les conditionnements externes (GTIN-14)."
      },
      "QRCode": {
        "name": "Code QR",
        "description": "Un code 2D qui stocke des URL, du texte et plus. Facile à scanner avec un téléphone."
      },
      "DataMatrix": {
        "name": "Data Matrix",
        "description": "Un code 2D compact utilisé en électronique, santé et marquage de petites pièces."
      },
      "Pdf417": {
        "name": "PDF417",
        "description": "Un code 2D empilé qui contient plus de données qu'un code 1D classique, utilisé sur les pièces d'identité, l'expédition et les billets."
      }
    }
  },
  "footer": {
    "tagline": "Conception professionnelle d'étiquettes pour imprimantes thermiques — Zebra et plus.",
    "privacy": "Confidentialité et conditions",
    "copyright": "© {{year}} DinLabel"
  },
  "install": {
    "title": "Télécharger",
    "intro": "Installez DinLabel sur Windows et commencez à concevoir des étiquettes pour imprimantes thermiques — notamment Zebra et d'autres imprimantes d'étiquettes Windows — en quelques minutes.",
    "windowsNote": "Installateur Windows (.exe). Compatible avec Windows 7 et versions ultérieures.",
    "requirements": "Configuration requise",
    "reqWindows": "Toute version de Windows à partir de Windows 7",
    "reqInternet": "Accès Internet",
    "reqRam": "1 Go de RAM",
    "reqDisk": "10 Go d'espace disque dur",
    "freeTag": "Version démo",
    "freeText": "La version démo inclut un filigrane sur les étiquettes imprimées.",
    "paidTitle": "Version complète",
    "paidText": "Sans filigranes — prête pour l'impression de production.",
    "buyApp": "Acheter l'application",
    "orDistributor": "Vous préférez acheter via un partenaire ?",
    "distributorsLink": "Voir les distributeurs",
    "emailModalTitle": "Télécharger la démo",
    "emailModalIntro": "Entrez votre adresse e-mail pour télécharger la démo DinLabel.",
    "emailLabel": "E-mail",
    "emailSubmit": "Télécharger",
    "emailInvalid": "Veuillez saisir une adresse e-mail valide.",
    "emailSubmitError": "Une erreur s'est produite. Veuillez réessayer.",
    "purchasedIntro": "Téléchargez et installez DinLabel pour commencer à utiliser votre version complète.",
    "signInTitle": "Comment se connecter",
    "signInStep1": "Téléchargez et installez DinLabel à l'aide du bouton ci-dessus.",
    "signInStep2": "Ouvrez DinLabel.",
    "signInStep3": "Choisissez Se connecter / S'inscrire dans le menu.",
    "signInStep4": "Connectez-vous avec le même compte Google que celui utilisé pour l'achat. Une fois connecté, vous utiliserez la version complète de DinLabel."
  },
  "fullTutorials": {
    "title": "Tutoriels",
    "intro": "Vidéos étape par étape pour vous aider à concevoir, imprimer et tirer le meilleur parti de DinLabel.",
    "howToRoll": "Comment créer une étiquette sur rouleau",
    "howToSheet": "Comment créer une étiquette sur planche",
    "howTo3Across": "Comment créer des étiquettes 3 de front",
    "howToText": "Comment ajouter du texte",
    "howToShapes": "Comment ajouter des formes",
    "howToImages": "Comment ajouter des images",
    "howToBarCodes": "Comment ajouter des codes-barres",
    "howToQR": "Comment ajouter des codes QR",
    "howToPrint": "Comment imprimer",
    "howToConsecutive": "Comment utiliser les numéros consécutifs",
    "howToDataBase": "Comment utiliser les bases de données",
    "howToBuy": "Comment acheter DinLabel",
    "alsoDistributor": "Des tutoriels spécifiques aux distributeurs sont disponibles dans le portail distributeurs.",
    "distributorLink": "Ouvrir le portail distributeurs"
  },
  "privacy": {
    "title": "Politique de confidentialité et conditions d'utilisation",
    "eulaLink": "Contrat de licence utilisateur final",
    "policyLink": "Politique de confidentialité",
    "note": "La politique de confidentialité ouvre le document HTML statique localisé.",
    "loading": "Chargement…",
    "eulaLoadError": "Impossible de charger le CLUF."
  },
  "distributors": {
    "title": "Distributeurs"
  },
  "buyPage": {
    "title": "S'abonner à DinLabel",
    "intro": "Débloquez la version complète avec un abonnement mensuel — sans filigranes, prête pour l'impression thermique et de production sur Zebra et d'autres imprimantes d'étiquettes.",
    "panelTitle": "Abonnement mensuel",
    "errorTitle": "Une erreur s'est produite",
    "thanks": "Merci de vous être abonné à DinLabel. Vous avez maintenant un accès complet à l'application !",
    "thanksLifetime": "Merci — vous avez déjà un accès à vie à DinLabel.",
    "checkAccount": "Vérifier l'état de votre compte",
    "goToDownload": "Aller à la page de téléchargement",
    "manageBilling": "Gérer la facturation",
    "price": "USD ${{price}}/mois + Taxes",
    "payWithCard": "S'abonner par carte",
    "payError": "Impossible de rediriger vers le paiement Stripe.",
    "adminTestMode": "Ceci est un utilisateur admin, le paiement utilisera donc le mode test. Utilisez la carte '4242 4242 4242 4242'.",
    "debugToggleBought": "Réservé aux admins : Debug : Basculer Bought",
    "toggleBoughtError": "Impossible de basculer l'état d'achat.",
    "orVia": "Vous préférez une autre option ?",
    "downloadDemo": "Télécharger une démo entièrement fonctionnelle"
  },
  "userInfo": {
    "title": "Mon compte",
    "detailsTitle": "Détails du compte",
    "quickLinks": "Liens rapides",
    "userId": "ID utilisateur",
    "email": "Adresse e-mail",
    "emailConfirmed": "E-mail confirmé",
    "confirmed": "Confirmé",
    "notConfirmed": "Non confirmé",
    "resend": "Renvoyer",
    "resentEmail": "E-mail de confirmation renvoyé à {{email}}",
    "resendError": "Impossible de renvoyer l'e-mail de confirmation.",
    "version": "Version de l'application",
    "freeVersion": "Version démo",
    "fullVersion": "Version complète",
    "lifetimeAccess": "Accès à vie",
    "subscription": "Abonnement",
    "subscriptionTitle": "Abonnement",
    "subscriptionStatus": "Statut",
    "subscriptionRenews": "Renouvellement le",
    "subscriptionEnds": "Accès jusqu'au",
    "subscriptionCancelScheduled": "Résiliation en fin de période",
    "subscriptionLoading": "Chargement de l'abonnement…",
    "subscriptionError": "Impossible de charger le statut de l'abonnement.",
    "manageBilling": "Gérer la facturation",
    "statusActive": "Actif",
    "statusTrialing": "Essai",
    "statusPastDue": "Impayé",
    "statusCanceled": "Résilié",
    "statusUnpaid": "Non payé",
    "statusIncomplete": "Incomplet",
    "statusIncompleteExpired": "Expiré",
    "statusPaused": "En pause",
    "statusUnknown": "{{status}}",
    "buyApp": "S'abonner",
    "accountType": "Compte",
    "admin": "Portail d'administration",
    "openDistributorPortal": "Ouvrir le portail distributeurs",
    "setPasswordTitle": "Ajouter un mot de passe",
    "setPasswordIntro": "Ajoutez un mot de passe pour vous connecter aussi par e-mail. Votre compte et licence restent les mêmes.",
    "changePasswordTitle": "Changer le mot de passe",
    "changePasswordIntro": "Mettez à jour le mot de passe pour la connexion e-mail.",
    "confirmEmailBeforePassword": "Confirmez votre e-mail avant d'ajouter un mot de passe.",
    "currentPassword": "Mot de passe actuel",
    "newPassword": "Nouveau mot de passe",
    "passwordHint": "Au moins 8 caractères",
    "setPasswordExpand": "Ajouter un mot de passe",
    "changePasswordExpand": "Changer le mot de passe",
    "passwordFormCancel": "Annuler",
    "setPasswordSubmit": "Enregistrer le mot de passe",
    "changePasswordSubmit": "Mettre à jour le mot de passe",
    "passwordSet": "Mot de passe enregistré. Vous pouvez vous connecter avec e-mail et mot de passe.",
    "passwordChanged": "Mot de passe mis à jour.",
    "passwordError": "Impossible de mettre à jour le mot de passe."
  },
  "myLabels": {
    "title": "Mes étiquettes",
    "loading": "Chargement…",
    "loadError": "Impossible de charger les étiquettes.",
    "empty": "Vous n'avez aucune étiquette enregistrée.",
    "name": "Nom",
    "date": "Date",
    "view": "Voir",
    "download": "Télécharger",
    "back": "Retour à mes étiquettes"
  },
  "admin": {
    "title": "Portail d'administration",
    "dataLink": "Tableau de bord d'analyse client DinLabel",
    "serverAnalyticsLink": "Tableau de bord d'analyse serveur",
    "fakeEmailLink": "E-mails fictifs",
    "loading": "Chargement…",
    "loadError": "Impossible de charger les données d'administration.",
    "totalUsers": "Utilisateurs totaux : {{count}}",
    "paidUsers": "Utilisateurs payants : {{count}}",
    "totalSubscribedUsers": "Total d'abonnés : {{count}}",
    "users": "Utilisateurs",
    "distributors": "Distributeurs",
    "payments": "Paiements distributeurs",
    "demoDownloaders": "Téléchargements démo",
    "authorize": "Autoriser"
  },
  "fakeEmail": {
    "title": "E-mails fictifs",
    "description": "Aperçu des modèles d'e-mail avec des données fictives.",
    "distributorSignUp": "Inscription distributeur",
    "activationLink": "Activation / confirmation d'e-mail",
    "sendEmailLicense": "Envoi de licence par le distributeur",
    "congratulationEmail": "Félicitations",
    "boughtLicensesMail": "Licences achetées",
    "demoDownloadThankYou": "Remerciement téléchargement démo",
    "subject": "Objet",
    "body": "Corps",
    "loading": "Chargement…",
    "loadError": "Impossible de charger cet e-mail.",
    "backAdmin": "Retour à l'administration",
    "testAddress": "Adresse de test",
    "testAddressPlaceholder": "vous@exemple.com",
    "sendTest": "Envoyer un test",
    "sendSuccess": "{{action}} envoyé à {{email}}",
    "sendError": "Échec de l'envoi de l'e-mail de test."
  }
}
